import { createShallowEqualSelector, getCompositeSettingSelector, TargetSelector } from "@client/selectors";

export const makeOverlayStyleSelector = () => {
  const overlaySelector = getCompositeSettingSelector<{ color: string; opacity: number }>(
    TargetSelector.Entity,
    "image.overlay"
  );

  return createShallowEqualSelector(
    [overlaySelector],
    (overlay): React.CSSProperties => ({
      display: overlay ? "block" : "none",
      backgroundColor: overlay?.color ?? "var(--color)",
      opacity: overlay?.opacity
    })
  );
};
